import React, { useState } from "react";

import { IEvent, IShow, ShowDto } from "@eagerdog/interfaces";

import { apiService } from "src/services/api.service";

import Input from "src/components/Input/Input";
import Button from "src/components/Button/Button";
import { toast } from "src/components/Toast/ToastManager";

import styles from "./ScentLocationsTab.module.scss";

interface IProps {
  event: IEvent,
  show: IShow,
}

const scentsDefault = [
  {
    scent: "Scent 1",
    location: "",
  },
  {
    scent: "Scent 2",
    location: "",
  },
  {
    scent: "Scent 3",
    location: "",
  },
  {
    scent: "Scent 4",
    location: "",
  },
];

const ScentLocationsTab = ({ event, show }: IProps) => {
  const [scents, setScents] = useState(show.scents?.length ? show.scents : scentsDefault);

  const handleScentChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.currentTarget?.value;
    setScents(prev => prev.map((item, i) =>
      i === index ? { ...item, scent: value } : item
    ));
  }

  const handleLocationChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.currentTarget?.value;
    setScents(prev => prev.map((item, i) =>
      i === index ? { ...item, location: value } : item
    ));
  }

  const handleSubmit = () => {
    const showData: ShowDto = { ...show };

    apiService.updateShow(event._id, show._id, { ...showData, scents })
      .then(() => {
        toast.show({
          title: "Update Scents Settings",
          content: "Scents Settings has been successfully updated",
          duration: 10000,
          type: "success"
        });
      })
      .catch(error => {
        toast.show({
          title: "Update Scents Settings",
          content: "Failed to update Scents Settings",
          duration: 10000,
          type: "fail"
        });
      });
  }

  return (
    <div className={styles.ScentLocationsTab}>
      {scents.map((scent, index) => {
        return (
          <div key={index}>
            <p>{`Scent ${index + 1}`}</p>
            <div className={styles.inputsGroup}>
              <Input
                label="Scent"
                defaultValue={scent.scent}
                onChange={(e) => handleScentChange(e, index)}
                placeholder={`Enter text for Scent ${index + 1}`}
              />
              <Input
                label="Located in/on"
                defaultValue={scent.location}
                onChange={(e) => handleLocationChange(e, index)}
                placeholder={`Enter location for Scent ${index + 1}`}
              />
            </div>
          </div>
        )
      })}
      <div className={styles.actions}>
        <Button isLoading={false} onClick={handleSubmit}>Save</Button>
      </div>
    </div>
  )
}

export { ScentLocationsTab }
